





















































































































import { defineComponent, ref, watchEffect } from '@vue/composition-api';

import { login, isClient } from '@/api';
import { loggedIn, saveCookie } from '@/utils/auth';
import store from '@/store';
import { SERVER_URL, TEST_SERVER_URL, PROD_SERVER_URL, MPF_ABOUT_URL } from '@/environment';

export default defineComponent({
  name: 'Login',
  setup(props, ctx) {
    // NOTE: May need to be computed ref
    const router = ctx.root.$router;

    const username = ref<string | null>(null);
    const password = ref<string | null>(null);
    const loginErrorMessage = ref<string | null>(null);

    const showAdvanced = ref(false);
    const useTestServer = ref(SERVER_URL === TEST_SERVER_URL);

    async function loginUser() {
      if (username.value && password.value) {
        const serverUrl = useTestServer.value ? TEST_SERVER_URL : PROD_SERVER_URL;
        const resp = await login(serverUrl, username.value, password.value);

        if (isClient(resp)) {
          saveCookie({ url: resp.serverURL });
          store.commit.setClient(resp);
        } else {
          loginErrorMessage.value = resp;
        }

        username.value = null;
        password.value = null;
      }
    }

    // Will re-route as soon as user is logged in
    watchEffect(() => {
      if (loggedIn.value) {
        router.push('/');
      }
    });

    return {
      SERVER_URL,
      MPF_ABOUT_URL,
      loginUser,
      loginErrorMessage,
      username,
      password,

      showAdvanced,
      useTestServer,
    };
  },
});
